import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2Zm0 2C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4Zm0 21a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-7-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm14 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3-7a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM6 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm14.363-6.872a1 1 0 0 1 .44 1.255l-.05.105-3.878 6.997-.009.015a1 1 0 0 1-.04.065l.049-.08a1.009 1.009 0 0 1-.566.466 1.318 1.318 0 0 1-.161.038.795.795 0 0 1-.031.004l-.031.003a1 1 0 0 1-.052.004H12a1 1 0 0 1-.117-1.993L12 15h3.41l3.594-6.482a1 1 0 0 1 1.36-.39ZM23 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM9 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm7-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcClock;
